import {
	GeneralGlobalCreationItemKind,
	GlobalCreationItem,
	GlobalCreationItemKind,
	HubCreationItemKind
} from "client/Api/GlobalCreation/globalCreation";
import {
	FontIconValueWithColor,
	SvgIconValue
} from "client/Components";
import { NewDocumentType } from "client/Api/Documents/common";
import { never } from "client_legacy/ndaw/errors";

export type GlobalCreationItemIcon =
	| FontIconValueWithColor
	| SvgIconValue;

export type GlobalCreationItemConfiguration = {
	nameKey: LocalizationKey;
	icon: GlobalCreationItemIcon;
	trackingId: string;
};

export function getGlobalCreationItemConfiguration(item: GlobalCreationItem): GlobalCreationItemConfiguration {
	switch (item.kind) {
		case GlobalCreationItemKind.General:
			return generalItemConfigurationMap[item.itemKind];
		case GlobalCreationItemKind.Hub:
			return hubItemConfigurationMap[item.itemKind];
		case GlobalCreationItemKind.File:
			return fileItemConfigurationMap[item.itemKind];
		default:
			never(item);
	}
}

const generalItemConfigurationMap: Record<GeneralGlobalCreationItemKind, GlobalCreationItemConfiguration> = {
	[GeneralGlobalCreationItemKind.Email]: {
		nameKey: "_Email",
		icon: { kind: "font", name: "envelope" },
		trackingId: "email"
	},
	[GeneralGlobalCreationItemKind.Appointment]: {
		nameKey: "_CalendarEvent",
		icon: { kind: "font", name: "calendar" },
		trackingId: "appointment"
	},
	[GeneralGlobalCreationItemKind.PersonalContact]: {
		nameKey: "_PersonalContact",
		icon: { kind: "font", name: "address-book" },
		trackingId: "personal-contact"
	},
	[GeneralGlobalCreationItemKind.SharedSpace]: {
		nameKey: "_SharedSpace",
		icon: { kind: "font", name: "rocket" },
		trackingId: "shared-space"
	}
};

const hubItemConfigurationMap: Record<HubCreationItemKind, GlobalCreationItemConfiguration> = {
	[HubCreationItemKind.Announcement]: {
		nameKey: "_Announcement",
		icon: { kind: "font", name: "bullhorn" },
		trackingId: "announcement"
	},
	[HubCreationItemKind.Event]: {
		nameKey: "_Event",
		icon: { kind: "font", name: "calendar-star" },
		trackingId: "event"
	},
	[HubCreationItemKind.KnowledgeItem]: {
		nameKey: "_KnowledgeArticle",
		icon: { kind: "font", name: "book" },
		trackingId: "knowledge-item"
	},
	[HubCreationItemKind.Community]: {
		nameKey: "_Community",
		icon: { kind: "font", name: "users" },
		trackingId: "community"
	},
	[HubCreationItemKind.CommunityPost]: {
		nameKey: "_CommunityPost",
		icon: { kind: "font", name: "pen-to-square" },
		trackingId: "community-post"
	}
};

const fileItemConfigurationMap: Record<NewDocumentType, GlobalCreationItemConfiguration> = {
	[NewDocumentType.Word]: {
		nameKey: "_WordDocument",
		icon: { kind: "svg", name: "docx" },
		trackingId: "word"
	},
	[NewDocumentType.Excel]: {
		nameKey: "_ExcelWorkbook",
		icon: { kind: "svg", name: "xlsx" },
		trackingId: "excel"
	},
	[NewDocumentType.PowerPoint]: {
		nameKey: "_PowerPointPresentation",
		icon: { kind: "svg", name: "powerpoint" },
		trackingId: "powerpoint"
	},
	[NewDocumentType.OneNote]: {
		nameKey: "_OneNoteNotebook",
		icon: { kind: "svg", name: "onenote" },
		trackingId: "onenote"
	}
};